const Td = ({ children, className, ...props }) => (
  <td className={`align-middle ${className}`} {...props}>{children}</td>
)

export default Td